import React, { useContext } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import CloseSliderIcon from '../../Icons/CloseSliderIcon';
// import CancelIcon from '../../Icons/CancelIcon';
import { TableContext } from '../TableContext';

// import ArrowLeftIcon from '../../Icons/ArrowLeftIcon';

interface TableSliderContentWrapperProps {
  label: string;
  children: React.ReactNode;
  loading?: boolean;
}

const TableSliderContentWrapper: React.FC<TableSliderContentWrapperProps> = ({
  label,
  children,
  loading,
}) => {
  const tableContext = useContext(TableContext);
  return (
    <Container>
      <HeaderArea>
        <div
          className='icon'
          onClick={() => tableContext?.setShowTableSlider(false)}
        >
          <CloseSliderIcon />
        </div>
        <div>{label}</div>
      </HeaderArea>
      {loading ? (
        <LoadingBox>
          <LoadingOutlined />
        </LoadingBox>
      ) : (
        <>{children}</>
      )}
    </Container>
  );
};

export default TableSliderContentWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: 32px;
  background-color: white;
  gap: 34px;
  /* background-color: red; */

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  overflow-y: auto;
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-weight: 600;
  font-size: 24px;
  width: 100%;
  height: fit-content;
  position: sticky;
  top: 0;
  background-color: #fff;

  @media (max-width: 884px) {
    font-size: 24px;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
  }

  & > .icon {
    cursor: pointer;

    @media (max-width: 884px) {
      display: none;
    }
  }

  & > .arrow_back_icon {
    display: none;

    @media (max-width: 884px) {
      display: block;
    }
  }
`;

const LoadingBox = styled.div`
  /* border: 1px solid red; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
